import * as React from 'react';
import * as DateHelpers from './DateHelpers';
import NotesPopup from './NotesPopup';
import JobQuoteDeliveryAddressData from './JobQuoteDeliveryAddressModal';
import { ItemOptionList, NewJobQuoteItem, DeliveryAddress } from './models/JobInterfaces';

interface NewJobPricelistEventProps {
    jobTypeId: number;
    customerQuoteNotesDunny: string;
    allowAllocateToPastDate: boolean;
    jobInstalled: boolean;
    isEventJob: boolean;
    schedulePickup: boolean;
    priceOnly: boolean;
    quoteItems: NewJobQuoteItem[];
    itemOptions: ItemOptionList[];
    customerChargeFuelSurcharge: boolean;
    chargeFuelSurchargeSwitchedOn: boolean;
    errors: { [key: string]: string };
    addItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    deleteItem(itemIndex: number): void;
    updateQuoteItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
}

interface EditNote {
    heading: string;
    rowIndex: number;
    parentIndex: number;
    id: number;
    itemId: number;
    item: string;
    notes: string;
}

const NewJobPricelistEventData = (props: NewJobPricelistEventProps) => {
    const [showEditNotesModal, setShowEditNotesModal] = React.useState(false);
    const [editNote, setEditNote] = React.useState<EditNote>({
        heading: "",
        id: 0,
        item: "",
        itemId: -1,
        notes: "",
        parentIndex: -1,
        rowIndex: -1
    });
    const [showDelAddress, setShowDelAddress] = React.useState(false);
    const [quoteItemIndex, setQuoteItemIndex] = React.useState(-1);
    const [deliveryAddress, setDeliveryAddress] = React.useState<DeliveryAddress>({
        deliveryAddress: "",
        deliveryAddressGooglePlaceId: "",
        deliveryAddressLatitude: 0,
        deliveryAddressLongitude: 0
    });
    const [invoiceDescription, setInvoiceDescription] = React.useState("");
    const [trolley, setTrolley] = React.useState(false);
    
    const handleCellChange = (e: any, itemIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value * 1;
        quoteItem[e.target.name] = value;

        if (e.target.name === "itemId") {
            item.hirePeriod = 1;
            item.hours = item.itemTypeId != 38 ? 0 : item.hours;    //attendant is the only item with hours
            item.isEvent = true;
            var itemOption = props.itemOptions.find(i => i.id === value);
            if (itemOption) {
                item.defaultHirePeriod = itemOption.priceListDefaultDays;
                item.installOnly = itemOption.installOnly;
                item.truck = itemOption.defaultTruckId;
                item.isEws = itemOption.isEws;
                item.itemTypeId = itemOption.typeId;
                item.item = itemOption.name;
                item.itemDescription = itemOption.description;
                //clear any extras as event items don't have extras
                item.extras.itemId = -1;
                item.extras.quantity = 0;
                item.extendable = itemOption.extendable;
                item.invoicePeriodTypeId = itemOption.invoicePeriodTypeId;
                item.productGroupId = itemOption.productGroupId;

                if (itemOption.typeId === 55) {
                    let stepsItems = quoteItems.filter(i => i.itemTypeId === 55);

                    if (stepsItems.length === 1) {
                        //need to check if this is our first steps row and if so set inc steps travel to true
                        item.incStepsTravel = true;
                    } else {
                        item.incStepsTravel = false;
                    }
                } else {
                    item.incStepsTravel = false;
                }
            }
        }

        if (itemIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        if (e.target.name === "amount" || e.target.name === "overhireRate") {
            //don't calculate price when updating amount / travel / overhire rate
            props.updateQuoteItem(quoteItem, false);
        } else {
            //calculate price
            props.updateQuoteItem(quoteItem, true);
        }
    }

    const handleCellAmountChange = (e: any, itemIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];
        item.amount = e.target.value;

        //calculate initial hire
        item.initialHire = (e.target.value * 1) - item.travel - item.fuelSurcharge;

        if (itemIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        //don't calculate price when updating amount
        props.updateQuoteItem(item, false);
    }

    const handleCellPriceChange = (e: any, itemIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value * 1;
        quoteItem[e.target.name] = value;

        //calculate amount
        item.amount = item.initialHire + item.travel + item.fuelSurcharge;

        if (itemIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        //don't calculate price when updating initial hire / travel
        props.updateQuoteItem(quoteItem, false);
    }

    const handleCellChangeText = (e: any, itemIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value;
        quoteItem[e.target.name] = value;

        if (itemIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        props.updateQuoteItem(item, false);
    }

    const handleScheduleDateChange = (e: any, itemIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value;
        quoteItem[e.target.name] = value;
        quoteItem["onHireDate"] = value;

        if (itemIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        props.updateQuoteItem(item, false);
    }

    const handleCellDateChange = (e: any, itemIndex: number) => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        let quoteItem: any = {};
        quoteItem = item;
        var value = e.target.value;
        quoteItem[e.target.name] = value;

        if (itemIndex === (quoteItems.length - 1)) {
            var newItem = addBlankQuoteItem();
            props.addItem(newItem, false);
        }

        if (item.scheduleDate && item.pickupDate) {
            //calculate hire period - add one as dates are inclusive
            item.hirePeriod = DateHelpers.daysBetweenDates(item.scheduleDate, item.pickupDate) + 1;
        }

        props.updateQuoteItem(item, false);
    }


    const addBlankQuoteItem = () => {
        var item: NewJobQuoteItem = {
            itemIndex: -1,
            itemId: -1,
            item: "",
            itemTypeId: -1,
            productGroupId: 0,
            itemDescription: "",
            installOnly: false,
            extendable: true,
            isEws: false,
            isWaste: false,
            isUnderground: false,
            isEvent: false,
            unitNumber: "",
            scheduleDate: "",
            onHireDate: "",
            offhireDate: "",
            pickupDate: "",
            hirePeriod: -1,
            defaultHirePeriod: 42,
            customHirePeriod: false,
            frequencyId: -1,
            locationId: -1,
            fenceBraceId: -1,
            hours: 0,
            size: 0,
            quantity: 1,
            unitOfMeasure: "",
            initialHire: 0,
            travel: 0,
            cleaning: 0,
            trench: 0,
            confinedSpace: 0,
            fuelSurcharge: 0,
            amount: 0,
            overhireRate: "0.00",
            truck: 0,
            truckDoors: -1,
            purchaseOrderNumber: "",
            purchaseOrderNumberFuel: "",
            notes: "",
            trolley: false,
            extras: {
                itemId: -1,
                quantity: 0,
                equipped: false
            },
            fencingStock: {
                panels: 0,
                blocks: 0,
                clamps: 0,
                pickets: 0,
                signs: 0,
                braces: 0
            },
            calculatedPriceNote: "",
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0,
            invoiceDescription: "",
            incStepsTravel: false,
            invoicePeriodTypeId: 1
        };

        return item;
    }

    //DELIVERY ADDRESS
    const editDelAddress = (e: any, itemIndex: number) => {
        e.preventDefault();

        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        setQuoteItemIndex(itemIndex);

        var delAddr: DeliveryAddress = {
            deliveryAddress: item.deliveryAddress,
            deliveryAddressGooglePlaceId: item.deliveryAddressGooglePlaceId,
            deliveryAddressLatitude: item.deliveryAddressLatitude,
            deliveryAddressLongitude: item.deliveryAddressLongitude
        };
        setDeliveryAddress(delAddr);
        setInvoiceDescription(item.invoiceDescription);
        setTrolley(item.trolley);
        setShowDelAddress(true);
    }

    const resetDeliveryAddress = () => {
        var delAddr: DeliveryAddress = {
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0
        };
        return delAddr;
    }

    const hideDelAddress = () => {
        setShowDelAddress(false);
        var delAddr = resetDeliveryAddress();
        setDeliveryAddress(delAddr);
        setInvoiceDescription("");
        setTrolley(false);
        setQuoteItemIndex(-1);
    }

    const updateDelAddress = (updatedDeliveryAddress: DeliveryAddress) => {
        setDeliveryAddress(updatedDeliveryAddress );
    }

    const clearDelAddress = () => {
        var delAddress = resetDeliveryAddress();
        setDeliveryAddress(delAddress);
    }

    const updateInvDesc = (updatedInvoiceDescription: string) => {
        setInvoiceDescription(updatedInvoiceDescription);
    }

    const updateTrolley = (updatedTrolley: boolean) => {
        setTrolley(updatedTrolley);
    }

    const saveDelAddress = () => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[quoteItemIndex];

        if (deliveryAddress.deliveryAddress != "") {
            item.deliveryAddress = deliveryAddress.deliveryAddress;
            item.deliveryAddressGooglePlaceId = deliveryAddress.deliveryAddressGooglePlaceId;
            item.deliveryAddressLatitude = deliveryAddress.deliveryAddressLatitude;
            item.deliveryAddressLongitude = deliveryAddress.deliveryAddressLongitude;
        }
        item.invoiceDescription = invoiceDescription;
        item.trolley = trolley;
  
        setQuoteItemIndex(-1);
        var delAddr = resetDeliveryAddress();
        setDeliveryAddress(delAddr);
        setInvoiceDescription("");
        setTrolley(false);
        setShowDelAddress(false);
        props.updateQuoteItem(item, true);
    }

    //END DELIVERY ADDRESS

    //NOTES
    const editNotes = (e: any, itemIndex: number) => {
        e.preventDefault();

        let quoteItems = props.quoteItems;
        let item = quoteItems[itemIndex];

        var note: EditNote = {
            heading: "Item Notes",
            parentIndex: 0,
            rowIndex: itemIndex,
            id: 0,
            itemId: item.itemId,
            item: "",
            notes: item.notes
        };

        setEditNote(note);
        setShowEditNotesModal(true);
    }

    const hideNotes = () => {
        let note = resetNotes();
        setEditNote(note);
        setShowEditNotesModal(false);
    }

    const updateNotes = (note: EditNote) => {
        setEditNote(prevState => ({ ...prevState, note }));
    }

    const resetNotes = () => {
        //reset
        var note: EditNote = {
            heading: "",
            parentIndex: 0,
            rowIndex: 0,
            id: 0,
            itemId: 0,
            item: "",
            notes: ""
        };

        return note;
    }

    const saveNotes = () => {
        let quoteItems = props.quoteItems;
        let item = quoteItems[editNote.rowIndex];

        item.notes = editNote.notes;

        let note = resetNotes();

        setEditNote(note);
        setShowEditNotesModal(false);
        props.updateQuoteItem(item, false);
    }
    //END NOTES

    const deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();
        props.deleteItem(itemIndex);
    }

    const delAddressPopup = <JobQuoteDeliveryAddressData deliveryAddress={deliveryAddress} showDeliveryAddress={true} invoiceDescription={invoiceDescription} showInvoiceDescription={true} trolleyRequired={trolley} showTrolley={true} readOnly={false} showModal={showDelAddress} hideModal={hideDelAddress} updateDeliveryAddress={updateDelAddress} clearDeliveryAddress={clearDelAddress} updateInvoiceDescription={updateInvDesc} updateTrolley={updateTrolley} saveModal={saveDelAddress} />
    const notesPopup = <NotesPopup showEditNotesModal={showEditNotesModal} editNotes={editNote} hideNotes={hideNotes} updateNotes={updateNotes} saveNotes={saveNotes} />
    const lastRowIndex = props.quoteItems.length - 1;
    const minDate = props.jobInstalled ? DateHelpers.addDaysToCurrentDate(-1500) : props.allowAllocateToPastDate ? DateHelpers.addDaysToCurrentDate(-90) : DateHelpers.addDaysToCurrentDate(-2);

    return (
        <div>
            <div className="static-modal">
                {notesPopup}
                {delAddressPopup}
            </div>
            <div>
                <div className="newJobPricelist--customer-notes">{props.customerQuoteNotesDunny}</div>
                <div className="overflowAuto">
                    <table className="table tableColours">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Item</th>
                                <th>Extra</th>
                                <th className={props.jobTypeId === 3 ? "hidden" : ""}>Unit #</th>
                                <th className={props.jobTypeId === 3 ? "hidden" : ""}>Delivery Date</th>
                                <th className={props.jobTypeId === 3 || (!props.isEventJob && !props.schedulePickup) ? "hidden" : ""}>Pickup Date</th>
                                <th>Hours</th>
                                <th>Quantity</th>
                                <th className={props.jobTypeId === 3 ? "hidden" : ""}>PO #</th>
                                <th>Initial Hire</th>
                                <th>Travel</th>
                                <th>Total Amount</th>
                                <th>Add. Hire Rate</th>
                                <th>Notes</th>
                                <th></th>
                            </tr>
                        </thead>
                        {props.quoteItems.map((item, index) =>
                            <tbody key={index}>
                                <tr key={index}>
                                    <td className="table__text--align">{index + 1}</td>
                                    <td className="table__text--align">
                                        <select className="select table__select--size newJobPricelist-item--size" id="itemId" name="itemId" value={item.itemId} onChange={(e) => handleCellChange(e, index)}>
                                            <option hidden defaultValue="-1"></option>
                                            {props.itemOptions.map(item =>
                                                props.isEventJob || props.priceOnly || (!props.isEventJob && !props.priceOnly && item.typeId != 33 && item.typeId != 42) ?
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                : ""
                                            )};
                                        </select>
                                    </td>
                                    <td className="table__text--align">
                                        <a className={item.itemId < 1 ? "hidden" : ""} href="#" onClick={(e) => editDelAddress(e, index)}>
                                            <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter tooltipitem tooltipitem__right" + (item.deliveryAddress === "" ? "" : " makeitgreen")}><span className="tooltipitemtext tooltipitemtext__right">Add a different delivery address</span></span>
                                        </a>
                                    </td>
                                    <td className={props.jobTypeId === 3 ? "hidden" : "table__text--align"}>
                                        <input type='text' maxLength={100} className="input allocate__qtySize" id="unitNumber" name="unitNumber" value={item.unitNumber} onChange={(e) => handleCellChangeText(e, index)} />
                                    </td>
                                    <td className={props.jobTypeId === 3 ? "hidden" : "table__text--align"}>
                                        <input type='date' min={minDate} className="input allocate__dateSize" id="scheduleDate" name="scheduleDate" value={item.scheduleDate} onChange={(e) => handleScheduleDateChange(e, index)} />
                                    </td>
                                    <td className={props.jobTypeId === 3 || (!props.isEventJob && !props.schedulePickup) ? "hidden" : "table__text--align"}>
                                        <input type='date' min={minDate} className={item.installOnly && item.itemTypeId != 35 ? "hidden" : "input allocate__dateSize"} id="pickupDate" name="pickupDate" value={item.pickupDate} onChange={(e) => handleCellDateChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="1" className={item.itemTypeId === 38 ? "input allocate__qtySize textalignright" : "hidden"} id="hours" name="hours" value={item.hours} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="1" className='input allocate__qtySize textalignright' id="quantity" name="quantity" value={item.quantity} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className={props.jobTypeId === 3 ? "hidden" : "table__text--align"}>
                                        <input type='text' maxLength={25} className="input table-input--minwidth" id="purchaseOrderNumber" name="purchaseOrderNumber" value={item.purchaseOrderNumber} onChange={(e) => handleCellChangeText(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='input textalignright table-input--minwidth' id="initialHire" name="initialHire" value={item.initialHire} onChange={(e) => handleCellPriceChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='input textalignright table-input--minwidth' id="travel" name="travel" value={item.travel} onChange={(e) => handleCellPriceChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='input textalignright table-input--minwidth' id="amount" name="amount" value={item.amount} onChange={(e) => handleCellAmountChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='input textalignright table-input--minwidth' id="overhireRate" name="overhireRate" value={item.overhireRate} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <a className={!item.notes ? "hidden" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, index)}>
                                            <div className="tooltipitem tooltipitem__left">{item.notes ? item.notes.substring(0, 20) + "... " : ""}
                                                <span className="tooltipitemtext tooltipitemtext__left">{item.notes}</span>
                                            </div>
                                        </a>
                                        <a className={!item.notes && lastRowIndex != index ? "" : "hidden"} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, index)}>
                                            <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                        </a>
                                    </td>
                                    <td className="table__text--align">
                                        {lastRowIndex != index ?
                                            <div className="delete--tablecell">
                                                <a className="makeitred" href="#" onClick={(e) => deleteItem(e, item.itemIndex)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                </a>
                                            </div> : ""
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                    {props.errors["eventQuoteItems"] ?
                        (props.errors["eventQuoteItems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
                <div className={props.isEventJob || props.priceOnly ? "hidden" : "newJobPricelist--customer-notes"}>NOTE: You can only book Event Toilets for Event / Short Term Hire Jobs. Please use Plastic Toilet instead.</div>
            </div>
        </div>
    )

}

export default NewJobPricelistEventData;